import { ProviderMachineInput } from '~/api/types';
import { OptionWithIdType } from '~/features/types';
import { getData } from '~/utils/service';
import { MEDICAL_BOARD_ROUTE_NAME } from './constants';

export const MEDICAL_BOARD_API_CALLS = {
  get: async ({
    input,
    transformResponse,
  }: ProviderMachineInput & {
    transformResponse?: (data: string) => OptionWithIdType[];
  }): Promise<OptionWithIdType[]> => {
    return await getData(MEDICAL_BOARD_ROUTE_NAME, {
      pathParams: { providerCategoryId: input.context.providerCategoryId.toString() },
      transformResponse: transformResponse,
    });
  },
};
